// extracted by mini-css-extract-plugin
export default {"productCarousel":"J1-z"};